import {Injectable} from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from './auth.service';
import {Roles} from '../model/enums';

/**
 * The VIP module is only available to support and VIP users.
 */
@Injectable({
  providedIn: 'root'
})
export class VipGuard implements CanActivate {

  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.auth.hasAnyRole([Roles.VIP, Roles.SUPPORT, Roles.DSI]).then( hasAnyRole => {
        if (hasAnyRole) {
          return true;
        } else {
          return this.router.parseUrl('/mobile');
        }
      },
      () => false);
  }

}
